import capitalize from 'lodash-es/capitalize'
import Router from 'next/router'
import ConfettiBackDrop from '#/components/ConfettiBackDrop'
import { ACADEMY_PAGE, PRICING_PAGE } from '#/consts/url'
import { showAlert } from '#/utils/message'

const showWelcomeMemberMessage = (
  planName: string,
  planPeriod: string,
  isSignUp?: boolean,
  isNew?: boolean,
  isGuest?: boolean,
  partner?: string
) => {
  showAlert({
    BackdropComponent: ConfettiBackDrop,
    content: (
      <div className='text-center' style={{ maxWidth: 300 }}>
        <h3 className='mb-4' style={{ color: 'black' }}>
          {isSignUp ? (
            'Thanks for signing up! 🎉'
          ) : isNew ? (
            <>
              Thanks for starting
              <br />
              your TopHap
              {' '}
              {planName}
              {' '}
              trial!&nbsp;🎉
            </>
          ) : (
            <>
              You have switched to the
              <br />
              {capitalize(planPeriod)}
              {' '}
              TopHap
              {planName}
              {' '}
              Plan&nbsp;🎉
            </>
          )}
        </h3>
        {isGuest || partner ? (
          <>
            To learn about TopHap features, visit&nbsp;
            <a href={ACADEMY_PAGE} rel='noreferrer' target='_blank'>
              TopHap Academy
            </a>
            .
          </>
        ) : (
          <>
            To upgrade your account, visit the&nbsp;
            <a
              className='text-primary hover:text-primary-dark'
              href={PRICING_PAGE}
              rel='noreferrer'
              target='_blank'
            >
              Pricing&nbsp;Page
            </a>
            .
          </>
        )}
      </div>
    ),
    okText: 'Continue'
  })
    .then(res => {
      if (res === 'OK') {
        const router = Router.router
        if (router) {
          router.push('/map')
        }
      }
    })
    .catch(console.error)
}

export default showWelcomeMemberMessage
